import { defineComponent } from '@vue/composition-api';

/**
 * @deprecated Use SdsBadge instead
 */
var script = defineComponent({
    name: 'SbBadge',
    props: {
        isBordered: {
            type: Boolean,
            required: false,
            default: false,
        },
        shape: {
            type: String,
            required: false,
            default: 'pill',
        },
        size: {
            type: String,
            required: false,
            default: 'medium',
        },
        theme: {
            type: String,
            required: false,
            default: 'success',
        },
    },
});

export default script;
